/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { CSSProperties, ReactNode } from 'react';

const wrapperStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  backgroundColor: 'transparent',
};

const badgeStyle: CSSProperties = {
  backgroundColor: 'rgb(211 178 91)',
  borderRadius: '5px',
  padding: '1px 6px',
  fontSize: '11px',
  lineHeight: '16px',
  color: '#000',
  fontWeight: 600,
};

export function BetaBadge({ children, testId }: { children: ReactNode; testId: string }) {
  return (
    <div style={wrapperStyle}>
      {children}
      <span data-testid={testId} style={badgeStyle}>
        Beta
      </span>
    </div>
  );
}
